module.exports = __webpack_public_path__ + "3dd394dcaa355ca181ce31a50f2ae4e4.jpg";